import { FeatureFlags } from '../constants/FeatureFlags';
import { usePublicFeatureFlags } from './usePublicFeatureFlags';
export function useIsPublicBundlePageEnabled() {
  const {
    featureFlags
  } = usePublicFeatureFlags();
  return featureFlags.includes(FeatureFlags.PUBLIC_BUNDLE_PAGE);
}